"use client";

import { useRouter } from "next/navigation";
import GuidedActivityCard from "../GuidedActivityCard";
import SectionHeader from "../SectionHeader";
import { useFetch } from "@/hooks/useFetch";
import { ActivityCardSkeleton } from "../ActivityCardSkeleton";
import { getNearbyActivities } from "@/services/activities-service";

export default function NearMeActivities({
  locLatitude = 6.5244,
  locLongitude = 3.3792,
  noOfRows = 20,
  region,
}: {
  locLatitude?: number;
  locLongitude?: number;
  noOfRows?: number;
  region?: string;
}) {
  const router = useRouter();

  const { data: nearMeData, loading } = useFetch(
    () => getNearbyActivities({ locLatitude, locLongitude }),
    [locLatitude, locLongitude]
  );

  // Shuffle helper
  const shuffleArray = <T,>(arr: T[]): T[] =>
    [...arr].sort(() => 0.5 - Math.random());

  if (!loading && (!nearMeData || nearMeData.length === 0)) {
    return null;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {loading && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <ActivityCardSkeleton count={4} />
        </div>
      )}

      {!loading &&
        nearMeData &&
        nearMeData.length > 0 &&
        nearMeData.map((group, groupIndex) => {
          const { title, description, activities, region } = group;
          if (!activities || activities.length === 0) return null;

          const displayActivities = shuffleArray(activities).slice(0, noOfRows);

          return (
            <div key={groupIndex} className="mb-14">
              <SectionHeader
                title={title || "Activities Near You"}
                subtitle={
                  description || "Explore activities happening around you"
                }
                onClickFunc={() => router.push(`/explore/query?city=${region}`)}
                actionText="See All"
              />

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                {displayActivities.map((activity, i) => (
                  <GuidedActivityCard key={i} activity={activity} />
                ))}
              </div>
            </div>
          );
        })}
    </div>
  );
}
